import React, { useEffect } from "react";
import { Header, FloatingButtons } from "../components/site/Chrome";
import { Hero } from "../components/site/Hero";
import { Services } from "../components/site/Services";
import { PilesFistula } from "../components/site/PilesFistula";
import { Doctors, About } from "../components/site/DoctorsAbout";
import { Emergency, Testimonials } from "../components/site/Sections";
import { LocationContact } from "../components/site/LocationContact";
import { Footer } from "../components/site/Footer";
import { useLenis } from "../hooks/useLenis";
import { useLang } from "../context/i18n";

export default function HomePage() {
  useLenis();
  const { lang } = useLang();
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  return (
    <div className={`min-h-screen bg-white ${lang === "hi" ? "lang-hi" : ""}`}>
      <Header />
      <main>
        <Hero />
        <Services />
        <PilesFistula />
        <Doctors />
        <About />
        <Emergency />
        <Testimonials />
        <LocationContact />
      </main>
      <Footer />
      <FloatingButtons />
      <div className="h-20 lg:hidden" />
    </div>
  );
}
